// Enable the calling extensions for all paid sales/service users
export const CallingLimitHigh = 'sales-calling-limit-high'; // (sales, service) x (pro, enterprise).
export const CallingLimitMedium = 'sales-calling-limit-medium'; // (sales, service) x (starter)
export const CallingIntegrations = 'calling-integrations';
export const CallingAccess = 'calling-access';